import { EntityTypeConfigurationHelper } from '@rightship-tech/common-ui/helpers/entity-type-configuration.helper';
import { DialogClientService } from '@rightship-tech/common-ui/services/basic/dialog-client.service';
import { autoinject } from 'aurelia-dependency-injection';
import { EntityTypeConfigurationModel } from '@rightship-tech/common-ui/components/comp-entity-finder/comp-entity-finder.models';
import { NotificationClientService, NotificationType } from '@rightship-tech/common-ui/services/basic/notification-client.service';
import { RightShipInspectionsService } from '../../../../../../services/rightship-inspections/rightship-inspections.service';

@autoinject
export class DialogSendRequestToServiceInspection {

    private _rsInspectionId: number;
    public selectedCompaniesAndInspectors: any[] = [];
    public vesselEntityTypeConfigurationModel: EntityTypeConfigurationModel[];
    public alreadyAdded: boolean;
    public isSubmitted: boolean;
    onVesselsAdded: () => void;

    constructor(private dialogClientService: DialogClientService, private inspectionService : RightShipInspectionsService,
        private entityTypeConfigurationHelper: EntityTypeConfigurationHelper, private notificationClientService: NotificationClientService) {
        this.vesselEntityTypeConfigurationModel = this.entityTypeConfigurationHelper.getConfigurationByKey(["CompanyOrFreelancedInspectors"]);
    }

    activate(params: { rsInspectionId }) {
        this._rsInspectionId = params.rsInspectionId;
    }   

    //Company or inspector selected
    companyOrInspectorSelected(event: any) {
        if (event.detail.selectedEntity) {
            
            //Reset validation UI
            this.alreadyAdded = false;
            const item: any = {
                companyId: event.detail.selectedEntity.inspectingCompanyId,
                companyName: event.detail.selectedEntity.companyName,
                name: event.detail.selectedEntity.inspectorId > 0 ? `${event.detail.selectedEntity.inspectorName} (${event.detail.selectedEntity.companyName})` : event.detail.selectedEntity.companyName,
                inspectorId: event.detail.selectedEntity.inspectorId,
                countryName: event.detail.selectedEntity.countryName ?? 'Unknown',
            };
            
            const findIndex = this.selectedCompaniesAndInspectors.findIndex(x => (
                x.companyId === item.companyId && item.companyId > 0 && item.companyName !== 'Individual'
            ) || ( x.inspectorId === item.inspectorId && item.inspectorId > 0 ));
            if (findIndex < 0) {
                this.selectedCompaniesAndInspectors.push(item);
            }
            else {
                this.notificationClientService.show("This company or inspector has already been added", "", NotificationType.Error);
            }
        }
    }

    //Remove company or inspector
    removeSelectedCompanyOrInspector(index: number) {
        this.selectedCompaniesAndInspectors.splice(index, 1);
    }

    //Save
    async save() {
        try {
            const companyIds = this.selectedCompaniesAndInspectors.map(x => x.companyId).filter(x => x);
            const freelancerIds = this.selectedCompaniesAndInspectors.map(x => x.inspectorId).filter(x => x);
            const response = await this.inspectionService.InviteInspector({ inspectionId: this._rsInspectionId, companyIds: companyIds, freelancerIds: freelancerIds});
            
            if (response.isSuccess) {
                this.notificationClientService.show(response.message ?? "Companies and/or inspectors have been added successfully!", "", NotificationType.Success);
                this.close();
            }
            else {
                this.notificationClientService.show(response.message ?? "Error adding companies and/or inspectors", "", NotificationType.Error);
            }

        } catch (error) {
            this.notificationClientService.show("Error adding companies and/or inspectors", "", NotificationType.Error);
            console.error("Error adding companies and/or inspectors:", error);
        }
    }

    //Close dialog
    close() {
        this.dialogClientService.hide(true, "default", true);
    }
}